export default __webpack_public_path__ + "images/330a9676ee4ff2bc0e27460e3e2f4aa5-punk_music_small.webp";